import Skeleton from './Skeleton'
import './Skeleton.css'

/**
 * Skeleton loading state for the RFQ/Requests table.
 * Matches the exact structure of the RFQ table for seamless transition.
 *
 * @param {number} rows - Number of skeleton rows to display (default: 5)
 */
function RFQTableSkeleton({ rows = 5 }) {
  return (
    <div className="table-container">
      <table className="rfq-table">
        <thead>
          <tr>
            <th>Request ID</th>
            <th>Carrier</th>
            <th>Route</th>
            <th>Shipment Type</th>
            <th>Status</th>
            <th>Submitted</th>
            <th>Price</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, index) => (
            <tr key={index} className="skeleton-row">
              {/* Request ID */}
              <td className="rfq-id-cell">
                <Skeleton variant="text" width="95px" height="0.9375rem" />
              </td>
              {/* Carrier name */}
              <td>
                <Skeleton variant="text" width="110px" height="0.9375rem" />
              </td>
              {/* Route - two lines (origin -> destination) */}
              <td className="route-cell">
                <div className="route-compact">
                  <Skeleton variant="text" width="100px" height="0.875rem" style={{ marginBottom: '4px' }} />
                  <Skeleton variant="text" width="18px" height="0.875rem" style={{ marginBottom: '4px' }} />
                  <Skeleton variant="text" width="100px" height="0.875rem" />
                </div>
              </td>
              {/* Shipment Type */}
              <td>
                <Skeleton variant="text" width="85px" height="0.9375rem" />
              </td>
              {/* Status badge */}
              <td>
                <Skeleton variant="rectangular" width="95px" height="24px" />
              </td>
              {/* Submitted date */}
              <td>
                <Skeleton variant="text" width="85px" height="0.9375rem" />
              </td>
              {/* Price */}
              <td className="price-cell">
                <Skeleton variant="text" width="70px" height="1.125rem" />
              </td>
              {/* Actions button */}
              <td className="actions-cell">
                <Skeleton variant="rectangular" width="90px" height="34px" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default RFQTableSkeleton
